import { Link } from "react-router-dom";
import { Mic } from "lucide-react";
import HostCard from "@/components/podcast/HostCard";
import StudioBackdrop from "@/components/podcast/StudioBackdrop";
import { StudioMic } from "@/components/podcast/StudioGear";
import { HOST_PHOTO_2 } from "@/data/site";

export default function AboutManuel() {
  return (
    <section
      data-testid="about-manuel"
      className="relative py-20 md:py-32 bg-[#0A0A0A] overflow-hidden film-grain"
    >
      {/* Studio backdrop */}
      <StudioBackdrop opacity={0.15} size={220} />

      {/* Big mic silhouette */}
      <StudioMic
        className="absolute -right-16 -top-8 w-96 hidden lg:block float-slow"
        color="#E10600"
        strokeWidth={1}
        style={{ opacity: 0.08 }}
      />

      {/* Big background outline word */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <p className="outline-text text-[14rem] md:text-[22rem] leading-none uppercase whitespace-nowrap">
          THE HOST
        </p>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -bottom-3 -left-3 w-full h-full border-2 border-[#E10600] hidden md:block" />
              <div className="absolute -top-3 -right-3 w-full h-full border-2 border-[#1E6FE0] hidden md:block" />
              <div className="relative" data-testid="about-host-card">
                <HostCard
                  name="Manuel Santana"
                  role="Host · Founder"
                  photo={HOST_PHOTO_2}
                  location="NYC · Boston"
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <p className="text-xs tracking-[0.25em] uppercase font-bold text-[#1E6FE0] mb-3">
              The Host
            </p>
            <h2 className="font-display text-5xl md:text-7xl uppercase tracking-tight leading-none">
              Meet <span className="text-[#E10600]">Manuel</span><br />Santana
            </h2>

            <div className="mt-8 space-y-5 text-zinc-300 leading-relaxed max-w-2xl">
              <p>
                Podcaster, cultural commentator, and the unfiltered voice behind Prove
                Your Point. Manuel hosts long-form conversations on the topics other
                shows soften — modern dating, masculine and feminine polarity,
                marriage, fatherhood, and the truth about what men and women actually
                want from each other. Based out of and filmed in{" "}
                <span className="text-[#1E6FE0] font-bold">New York City</span> and{" "}
                <span className="text-[#E10600] font-bold">Boston</span>.
              </p>
              <blockquote className="border-l-2 border-[#E10600] pl-6 italic text-white text-xl font-light">
                "If you can't prove your point, somebody else will define it for you.
                Both sides have to come to the table — that's where the real
                conversation lives."
              </blockquote>
            </div>

            {/* Quick credential tiles */}
            <div className="mt-10 grid grid-cols-2 gap-px bg-[#262626] border border-[#262626] max-w-xl">
              <Cred icon={Mic} label="Filmed In" value="NYC · Boston" color="#E10600" />
              <Cred icon={Mic} label="Live" value="Mon 7PM EST" color="#1E6FE0" />
            </div>

            <div className="mt-10 flex flex-wrap gap-4">
              <Link to="/about" data-testid="about-cta-bio" className="btn-primary">
                Read The Full Story
                <span className="ml-1">→</span>
              </Link>
              <Link to="/contact" data-testid="about-cta-booking" className="btn-blue">
                Booking Inquiries
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Cred({ icon: Icon, label, value, color = "#E10600" }) {
  return (
    <div className="bg-[#0A0A0A] p-4 md:p-5">
      <Icon className="w-5 h-5 mb-3" style={{ color }} />
      <p className="font-display text-3xl uppercase leading-none text-white">{value}</p>
      <p className="text-[10px] tracking-[0.2em] uppercase text-zinc-500 mt-2 font-mono">
        {label}
      </p>
    </div>
  );
}
